import React from 'react'
import { PageWrapper } from './PageWrapper'
import { Heading, Text, Input } from 'base-ui'
import CodeSampleSelector from './CodeSampleSelector'
import { Input as InputExample } from '../examples/Input'
import { Input as AlgoliaInputExample } from '../examples/Input/algolia-input'

const handleChange = () => {
  alert('Input has changed')
}
const Inputs = () => {
  
  return (
    <PageWrapper title="Inputs">
      <Text size="lg">The Input component is a component that is used to get user input in a text field.</Text>
      <div className="py-2">
        <Input 
          label="Input Label"
          type="text"
          value="Any Value"
          name="my-input-text"
          id="custom-id"
          onChange={handleChange}
          placeholder="Name"
          className="custom-class-name"
          isInvalid={false}
          isInvalidText="Please enter a valid name"
          isRequired={true}
        />
      </div>

      <Heading size="h3">Input States</Heading>
      <div className="py-2">
        <div className="space-x-8 flex">
          <div className='flex-1'>
            <Input 
              label="Empty"
              type="text"
              value=""
              name="my-input-text"
              id="custom-id"
              onChange={handleChange}
              placeholder="Placeholder"
              isInvalidText="Please enter a valid name"
            />
          </div>
          <div className='flex-1'>
            <Input 
              label="Default"
              type="text"
              value="Any Value"
              name="my-input-text"
              id="custom-id"
              onChange={handleChange}
              placeholder="Name"
              isInvalidText="Please enter a valid name"
            />
          </div>
        </div>
      </div>

    <div className="space-x-8 flex py-2">
      <div className='flex-1'>
            <Input 
              label="Error"
              type="text"
              value="Any Value"
              name="my-input-text"
              id="custom-id"
              onChange={handleChange}
              placeholder="Name"
              isInvalid={true}
              isInvalidText="Please enter a valid/requiered name"
              isRequired={true}
            />
          </div>
          <div className='flex-1'>
            <Input 
              label="Disabled"
              type="text"
              value="Any Value"
              name="my-input-text"
              id="custom-id"
              onChange={handleChange}
              placeholder="Name"
              disabled={true}
              className='custom-class'
            />
          </div>
        </div>

      <Heading size="h3">Usage</Heading>
      <CodeSampleSelector
        baseUi={InputExample}
        algoliaUi={AlgoliaInputExample}
      />
      
      
     
    </PageWrapper>
  )
}

export default Inputs
